import React from 'react'
import Navbar from '../Navbar';
import PropertyRentals from '../PropertyRentels';
function RentalIndex() {
  return (
    <div>
      <Navbar />
      <PropertyRentals />
    </div>
  )
}

export default RentalIndex
